import { AccordionState } from "PFComponents/accordion";
import { useCallback, useEffect, useState } from "react";

export const useAccordionTrigger = (searchTerm: string) => {
  const [stateTrigger, setStateTrigger] = useState<AccordionState | undefined>("open");

  useEffect(() => {
    setStateTrigger("open");
  }, [searchTerm]);

  const handleStateChange = useCallback(() => {
    setTimeout(() => {
      // Avoid accordion lag by postponing setStateTrigger
      setStateTrigger(undefined);
    }, 0);
  }, []);

  return {
    stateTrigger,
    handleStateChange
  };
};
